import React, { useState, useEffect } from "react";
import { api } from '../../services/api.js';
import { useNavigate } from 'react-router-dom';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import { formatInTimeZone } from 'date-fns-tz';
import InputMask from 'react-input-mask';
import Cropper from 'react-easy-crop';
import getCroppedImg from '../Utils/cropImage.js';
import { FaUser, FaCamera, FaCreditCard, FaMedkit, FaPhone, FaWhatsapp, FaEnvelope, FaMapMarkerAlt, FaBriefcase, FaMoneyBillWave, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import './index.css';

function DadosFunc() {
  const navigate = useNavigate();
  const [nome, setNome] = useState('');
  const [admissao, setAdmissao] = useState('');
  const [dtadmissao, setDtAdmissao] = useState('');
  const [horario, setHorario] = useState('');
  const [codfilial, setCodFilial] = useState(0);
  const [loja, setLoja] = useState(0);
  const [secao, setSecao] = useState('');
  const [funcao, setFuncao] = useState('');
  const [cpf, setCpf] = useState(0);

  const [endereco, setEndereco] = useState('');
  const [numero, setNumero] = useState('');
  const [bairro, setBairro] = useState('');
  const [cidade, setCidade] = useState('');
  const [complemento, setComplemento] = useState('');
  const [nascimento, setNascimento] = useState('');
  const [email, setEmail] = useState('');

  const [estado, setEstado] = useState('');
  const [codcep, setCodcep] = useState(0);
  const [whatsapp, setWhatsApp] = useState('');
  const [fixo, setFixo] = useState('');
  const [contato, setContato] = useState('');
  const [salario, setSalario] = useState(0);
  const [foto, setFoto] = useState('');
  const [imagem, setImagem] = useState();
  const [valcelular, setValcelular] = useState('');
  const [valfixo, setValfixo] = useState('');
  const [valcontato, setValcontato] = useState('');
  const [valemail, setValemail] = useState('');
  const [valendereco, setValendereco] = useState('');

  // Assistência e Convênio
  const [assistvalor, setAssistValor] = useState(0);
  const [assistlimite, setAssistLimite] = useState(0);
  const [assistdata, setAssistData] = useState('');
  const [assistfim, setAssistFim] = useState('');
  const [assistpend, setAssistPend] = useState(0);
  const [convstatus, setConvStatus] = useState('');
  const [convlimite, setConvLimite] = useState(0);
  const [convutilizado, setConvUtilizado] = useState(0);
  const [convsaldo, setConvSaldo] = useState(0);

  const chapa = localStorage.getItem("chapa");
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedImagePreview, setCroppedImagePreview] = useState(null);

  useEffect(() => {
    const chapaStorage = localStorage.getItem("chapa");
    if (!chapaStorage) {
      navigate("/arbor/login");
    }
  }, [navigate]);

  const phoneMask = (value) => {
    if (!value) return "";
    value = value.replace(/\D/g, '');
    value = value.replace(/(\d{2})(\d)/, "($1) $2");
    value = value.replace(/(\d)(\d{4})$/, "$1-$2");
    return value;
  };

  function formatLeadingZero(text) {
    if (!text) return '';
    const str = String(text);
    if (str.length === 13) return `0${str}`;
    if (parseInt(str, 10) < 100) return `0${str}`;
    return str;
  }

  function CalculaIdade(dateString) {
    if (!dateString) return '';
    const date1 = new Date();
    const date2 = new Date(dateString);

    let anos = date1.getFullYear() - date2.getFullYear();
    let meses = date1.getMonth() - date2.getMonth();

    if (meses < 0) {
      anos--;
      meses += 12;
    }

    let dias = date1.getDate() - date2.getDate();
    if (dias < 0) {
      meses--;
      if (meses < 0) {
        anos--;
        meses += 12;
      }
      dias += new Date(date2.getFullYear(), date2.getMonth(), 0).getDate();
    }

    return `${anos} anos, ${meses} meses e ${dias} dias`;
  }

  const formatNumber = (amount) => {
    const val = Number(amount) || 0;
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val);
  };

  useEffect(() => {
    if (!chapa) return;

    setFoto('https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg');
    api.get('/usuario/dados/' + chapa)
      .then((retorno) => {
        if (retorno.data && retorno.data[0]) {
          const d = retorno.data[0];
          setNome(d.nome);
          setAdmissao(formatInTimeZone(d.dataadmissao.substring(0, 23), 'America/Sao_Paulo', "dd/MM/yyyy"));
          setDtAdmissao(formatInTimeZone(d.dataadmissao.substring(0, 23), 'America/Sao_Paulo', "yyyy/MM/dd"));
          setHorario(d.deschorario);
          setCodFilial(d.codfilial);
          setLoja(d.loja);
          setSecao(d.secao);
          setFuncao(d.funcao);
          setCpf(d.cpf);
          setSalario(d.salario);

          setEndereco(d.rua);
          setNumero(d.numero);
          setBairro(d.bairro);
          setCidade(d.cidade);
          setComplemento(d.complemento);
          setNascimento(formatInTimeZone(d.dtnascimento.substring(0, 23), 'America/Sao_Paulo', "dd/MM/yyyy"));
          setEmail(d.email);

          setEstado(d.estado);
          setCodcep(d.cep);
          setWhatsApp(d.telefone2);
          setFixo(d.telefone1);
          setContato(d.telefone3);

          setValcelular(d.usr_telefonecelular);
          setValcontato(d.usr_telefone3);
          setValfixo(d.usr_telefofixo);
          setValemail(d.usr_emailcheck);
          setValendereco(d.usr_endereco);

          setAssistData(formatInTimeZone(d.assistdata.substring(0, 23), 'America/Sao_Paulo', "dd/MM/yyyy"));
          setAssistFim(formatInTimeZone(d.assistfim.substring(0, 23), 'America/Sao_Paulo', "dd/MM/yyyy"));
          setAssistLimite(d.assistlimite);
          setAssistPend(d.assistpend);
          setAssistValor(d.assistvalor);

          setConvLimite(d.convlimite);
          setConvSaldo(d.convsaldo);
          setConvStatus(d.convstatus);
          setConvUtilizado(d.convutilizado);

          BuscarFoto();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [chapa]);

  function BuscarFoto() {
    api.get('/usuario/foto/' + chapa)
      .then((retorno) => {
        if (retorno.data && retorno.data.foto) {
          setFoto('data:image/jpeg;base64,' + retorno.data.foto);
          setImagem(null);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function gravarfoto() {
    try {
      const croppedUrl = await getCroppedImg(imagem, croppedAreaPixels);
      const response = await fetch(croppedUrl);
      const blob = await response.blob();

      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = async () => {
        const base64Image = reader.result;
        setImagem(base64Image);

        const data = {
          tipo: 'PERFIL',
          imagem: base64Image,
          loja,
        };

        await api.post('/usuario/foto/' + chapa, data);
        BuscarFoto();
      };
    } catch (err) {
      console.error(err);
      alert('Erro ao recortar imagem');
    }
  }

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.addEventListener('load', () => {
      setImagem(reader.result);
    });
    reader.readAsDataURL(file);
  };

  const onCropComplete = async (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
    if (imagem) {
      try {
        const croppedUrl = await getCroppedImg(imagem, croppedAreaPixels);
        setCroppedImagePreview(croppedUrl);
      } catch (err) {
        console.error('Erro ao gerar preview:', err);
      }
    }
  };

  return (
    <div className="bg-light min-vh-100" style={{ paddingTop: '80px', paddingBottom: '40px' }}>
      <Menu modulo="ARBOR" />

      {/* MODAL DE ALTERAÇÃO DE FOTO */}
      <div className="modal fade" id="exampleModal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4 border-0 shadow">
            <div className="modal-header bg-danger text-white border-0">
              <h5 className="modal-title fw-bold" id="exampleModalLabel">Alterar Foto de Perfil</h5>
              <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close" onClick={() => { setImagem(null); setCroppedImagePreview(null); }}></button>
            </div>
            <div className="modal-body p-4 text-center">
              {imagem ? (
                <>
                  <div style={{ position: 'relative', width: '100%', height: 280 }} className="rounded-3 overflow-hidden border mb-3">
                    <Cropper
                      image={imagem}
                      crop={crop}
                      zoom={zoom}
                      aspect={1}
                      onCropChange={setCrop}
                      onZoomChange={setZoom}
                      onCropComplete={onCropComplete}
                    />
                  </div>
                  {croppedImagePreview && (
                    <div>
                      <small className="text-muted d-block mb-2 fw-semibold">Pré-visualização:</small>
                      <img
                        src={croppedImagePreview}
                        alt="Pré-visualização"
                        style={{ width: 100, height: 100, borderRadius: '50%', objectFit: 'cover', border: '3px solid #8b0000' }}
                      />
                    </div>
                  )}
                </>
              ) : (
                <img 
                  className="rounded-circle shadow border border-3 border-danger" 
                  alt="Foto" 
                  style={{ width: 180, height: 180, objectFit: 'cover' }}
                  src={foto || 'https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg'} 
                />
              )}
            </div>
            <div className="modal-footer border-top justify-content-between p-3">
              <div>
                <input type="file" name="file" id="file" className="inputfile d-none" onChange={handleChange} accept=".png,.jpg,.jpeg" />
                <label htmlFor="file" className="btn btn-sm btn-dark fw-bold px-3 py-2 rounded-3 cursor-pointer">
                  <FaCamera className="me-1" /> Buscar foto
                </label>
              </div>
              <div className="d-flex gap-2">
                <button type="button" className="btn btn-sm btn-outline-secondary fw-bold rounded-3" data-bs-dismiss="modal" onClick={() => { setImagem(null); setCroppedImagePreview(null); }}>
                  Cancelar
                </button>
                {imagem && (
                  <button type="button" className="btn btn-sm btn-danger fw-bold rounded-3" style={{ background: 'linear-gradient(135deg, #8b0000 0%, #c0392b 100%)', border: 'none' }} data-bs-dismiss="modal" onClick={gravarfoto}>
                    Gravar Foto
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CONTAINER PRINCIPAL CENTRALIZADO */}
      <div className="container-fluid py-3 px-3 px-md-5" style={{ maxWidth: '1000px', margin: '0 auto' }}>
        
        {/* CARD PRINCIPAL DE PERFIL */}
        <div className="card border-0 shadow-sm rounded-4 overflow-hidden bg-white mb-4">
          <div className="card-header text-white p-4 text-center position-relative" style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)' }}>
            <div className="position-relative d-inline-block mb-2">
              <img 
                src={foto || "https://upload.wikimedia.org/wikipedia/commons/0/03/Sem_imagem.jpg"} 
                alt="Foto do Funcionário" 
                className="rounded-circle shadow border border-3 border-white"
                style={{ width: '110px', height: '110px', objectFit: 'cover' }}
              />
              <button 
                type="button" 
                className="btn btn-sm btn-danger rounded-circle position-absolute bottom-0 end-0 p-2 shadow"
                data-bs-toggle="modal" 
                data-bs-target="#exampleModal"
                style={{ width: '36px', height: '36px' }}
              >
                <FaCamera size={14} />
              </button>
            </div>

            <h5 className="fw-bold m-0 text-white">{nome || 'Carregando...'}</h5>
            <small className="text-white-50 d-block mt-1">{funcao} • {secao}</small>
            
            {dtadmissao && (
              <span className="badge bg-white text-dark mt-2 fw-semibold px-3 py-1 shadow-sm">
                Tempo de Empresa: {CalculaIdade(dtadmissao)}
              </span>
            )}
          </div>

          <div className="card-body p-3 p-md-4">
            <form>
              {/* SEÇÃO 1: DADOS CONTRATUAIS */}
              <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center">
                <FaBriefcase className="me-2 text-danger" /> Informações Contratuais
              </h6>

              <div className="row g-2 mb-4">
                <div className="col-6 col-md-3">
                  <label className="form-label extra-small text-muted fw-bold">Chapa</label>
                  <input type="text" value={chapa || ''} className="form-control form-control-sm text-center fw-bold bg-light" disabled />
                </div>
                <div className="col-6 col-md-3">
                  <label className="form-label extra-small text-muted fw-bold">CPF</label>
                  <InputMask mask="999.999.999-99" value={formatLeadingZero(cpf)} className="form-control form-control-sm text-center bg-light" disabled />
                </div>
                <div className="col-6 col-md-3">
                  <label className="form-label extra-small text-muted fw-bold">Loja / Filial</label>
                  <input type="text" value={`Lj ${formatLeadingZero(loja)} / Fl ${formatLeadingZero(codfilial)}`} className="form-control form-control-sm text-center bg-light" disabled />
                </div>
                <div className="col-6 col-md-3">
                  <label className="form-label extra-small text-muted fw-bold">Admissão</label>
                  <input type="text" value={admissao || ''} className="form-control form-control-sm text-center bg-light" disabled />
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label extra-small text-muted fw-bold">Horário de Trabalho</label>
                  <input type="text" value={horario || ''} className="form-control form-control-sm bg-light" disabled />
                </div>
                <div className="col-6 col-md-3">
                  <label className="form-label extra-small text-muted fw-bold">Nascimento</label>
                  <input type="text" value={nascimento || ''} className="form-control form-control-sm text-center bg-light" disabled />
                </div>
                <div className="col-6 col-md-3">
                  <label className="form-label extra-small text-muted fw-bold">Salário Base</label>
                  <input type="text" value={formatNumber(salario)} className="form-control form-control-sm text-end fw-bold text-success bg-light" disabled />
                </div>
              </div>

              {/* SEÇÃO 2: ENDEREÇO */}
              <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center border-top pt-3">
                <FaMapMarkerAlt className="me-2 text-danger" /> Endereço Residencial
                {valendereco === 'S' ? <FaCheckCircle className="text-primary ms-2" title="Validado" /> : <FaTimesCircle className="text-muted ms-2" title="Pendente" />}
              </h6>

              <div className="row g-2 mb-4">
                <div className="col-9 col-md-8">
                  <label className="form-label extra-small text-muted fw-bold">Logradouro</label>
                  <input type="text" value={endereco || ''} className="form-control form-control-sm bg-light" disabled />
                </div>
                <div className="col-3 col-md-2">
                  <label className="form-label extra-small text-muted fw-bold">Nº</label>
                  <input type="text" value={numero || ''} className="form-control form-control-sm text-center bg-light" disabled />
                </div>
                <div className="col-12 col-md-2">
                  <label className="form-label extra-small text-muted fw-bold">CEP</label>
                  <InputMask mask="99.999-999" value={formatLeadingZero(codcep)} className="form-control form-control-sm text-center bg-light" disabled />
                </div>

                <div className="col-6 col-md-4">
                  <label className="form-label extra-small text-muted fw-bold">Complemento</label>
                  <input type="text" value={complemento || ''} className="form-control form-control-sm bg-light" disabled />
                </div>
                <div className="col-6 col-md-4">
                  <label className="form-label extra-small text-muted fw-bold">Bairro</label>
                  <input type="text" value={bairro || ''} className="form-control form-control-sm bg-light" disabled />
                </div>
                <div className="col-8 col-md-3">
                  <label className="form-label extra-small text-muted fw-bold">Cidade</label>
                  <input type="text" value={cidade || ''} className="form-control form-control-sm bg-light" disabled />
                </div>
                <div className="col-4 col-md-1">
                  <label className="form-label extra-small text-muted fw-bold">UF</label>
                  <input type="text" value={estado || ''} className="form-control form-control-sm text-center bg-light" disabled />
                </div>
              </div>

              {/* SEÇÃO 3: CONTATO */}
              <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center border-top pt-3">
                <FaPhone className="me-2 text-danger" /> Meios de Contato
              </h6>

              <div className="row g-2 mb-4">
                <div className="col-12 col-md-4">
                  <label className="form-label extra-small text-muted fw-bold d-flex align-items-center gap-1">
                    <FaWhatsapp className="text-success" /> WhatsApp {valcelular === 'S' ? <FaCheckCircle className="text-primary" /> : <FaTimesCircle className="text-muted" />}
                  </label>
                  <input type="text" value={phoneMask(whatsapp)} className="form-control form-control-sm text-center bg-light" disabled />
                </div>
                <div className="col-6 col-md-4">
                  <label className="form-label extra-small text-muted fw-bold d-flex align-items-center gap-1">
                    <FaPhone className="text-secondary" /> Fixo {valfixo === 'S' ? <FaCheckCircle className="text-primary" /> : <FaTimesCircle className="text-muted" />}
                  </label>
                  <input type="text" value={phoneMask(fixo)} className="form-control form-control-sm text-center bg-light" disabled />
                </div>
                <div className="col-6 col-md-4">
                  <label className="form-label extra-small text-muted fw-bold d-flex align-items-center gap-1">
                    Recado {valcontato === 'S' ? <FaCheckCircle className="text-primary" /> : <FaTimesCircle className="text-muted" />}
                  </label>
                  <input type="text" value={phoneMask(contato)} className="form-control form-control-sm text-center bg-light" disabled />
                </div>

                <div className="col-12">
                  <label className="form-label extra-small text-muted fw-bold d-flex align-items-center gap-1">
                    <FaEnvelope className="text-danger" /> E-mail {valemail === 'S' ? <FaCheckCircle className="text-primary" /> : <FaTimesCircle className="text-muted" />}
                  </label>
                  <input type="text" value={email || ''} className="form-control form-control-sm bg-light" disabled />
                </div>
              </div>

              {/* SEÇÃO 4: BENEFÍCIOS E AEFLOR */}
              <h6 className="fw-bold text-secondary mb-3 d-flex align-items-center border-top pt-3">
                <FaMedkit className="me-2 text-danger" /> Benefícios & AEFLOR
              </h6>

              {/* Assistência */}
              <div className="p-3 bg-light rounded-3 border mb-3">
                <span className="fw-bold text-dark small d-block mb-2">Assistência AEFLOR</span>
                <div className="row text-center g-2">
                  <div className="col-6 col-md-2.4">
                    <small className="text-muted d-block extra-small">Limite</small>
                    <span className="fw-bold text-dark small">{formatNumber(assistlimite)}</span>
                  </div>
                  <div className="col-6 col-md-2.4">
                    <small className="text-muted d-block extra-small">Pendente</small>
                    <span className="fw-bold text-danger small">{formatNumber(assistpend)}</span>
                  </div>
                  <div className="col-4 col-md-2.4">
                    <small className="text-muted d-block extra-small">Última Ass.</small>
                    <span className="fw-bold text-dark small">{formatNumber(assistvalor)}</span>
                  </div>
                  <div className="col-4 col-md-2.4">
                    <small className="text-muted d-block extra-small">Data</small>
                    <span className="fw-bold text-dark small">{assistdata || '--/--/----'}</span>
                  </div>
                  <div className="col-4 col-md-2.4">
                    <small className="text-muted d-block extra-small">Prazo</small>
                    <span className="fw-bold text-dark small">{assistfim || '--/--/----'}</span>
                  </div>
                </div>
              </div>

              {/* Convênio */}
              <div className="p-3 bg-light rounded-3 border">
                <span className="fw-bold text-dark small d-block mb-2">Convênio AEFLOR</span>
                <div className="row text-center g-2">
                  <div className="col-12 col-md-3">
                    <small className="text-muted d-block extra-small">Status</small>
                    <span className={`badge ${convstatus === 'L' ? 'bg-success' : 'bg-danger'} text-white extra-small mt-1`}>
                      {convstatus === 'L' ? 'LIBERADO PARA COMPRA' : 'BLOQUEADO'}
                    </span>
                  </div>
                  <div className="col-4 col-md-3">
                    <small className="text-muted d-block extra-small">Limite</small>
                    <span className="fw-bold text-dark small">{formatNumber(convlimite)}</span>
                  </div>
                  <div className="col-4 col-md-3">
                    <small className="text-muted d-block extra-small">Utilizado</small>
                    <span className="fw-bold text-danger small">{formatNumber(convutilizado)}</span>
                  </div>
                  <div className="col-4 col-md-3">
                    <small className="text-muted d-block extra-small">Saldo</small>
                    <span className="fw-bold text-success small">{formatNumber(convsaldo)}</span>
                  </div>
                </div>
              </div>

            </form>
          </div>
        </div>

      </div>

      <Footer />
    </div>
  );
}

export default DadosFunc;